<template>
  <widget
    @closed="$emit('closed')"
    @search="toggleSearch"
    title="totale assenze e presenze"
    icon="mdi-account-group"
    dark
    :bgColor="colors.orange"
    searchButton
    scroll
  >
    <transition name="fade" appear>
      <search-bar v-if="searchBtn" @search="updateData"></search-bar>
    </transition>
    <v-row no-gutters>
      <v-col cols="6">
        <v-row no-gutters>
          <v-col cols="12">
            <v-card flat tile>
              <div class="text-caption text-center title">Assenze/presenze</div>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card outlined flat tile>
              <div class="text-center head text-caption">
                {{ item.mese }} {{ item.anno }}
              </div>
            </v-card>
          </v-col>
          <v-col cols="8">
            <v-card outlined flat tile class="px-1 text-truncate text-caption">
              Lavorate ore
            </v-card>
          </v-col>
          <v-col cols="4">
            <v-card outlined flat tile class="px-1 text-caption">{{
              item.presenze.lavorate
            }}</v-card>
          </v-col>
          <v-col cols="8">
            <v-card outlined flat tile class="px-1 text-truncate text-caption"
              >Straordinario ore</v-card
            >
          </v-col>
          <v-col cols="4">
            <v-card outlined flat tile class="px-1 text-caption">{{
              item.presenze.straordinario
            }}</v-card>
          </v-col>
          <v-col cols="8">
            <v-card outlined flat tile class="px-1 text-truncate text-caption"
              >Assenze ore</v-card
            >
          </v-col>
          <v-col cols="4">
            <v-card outlined flat tile class="px-1 text-caption">{{
              item.assenze.totale
            }}</v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6">
        <v-row no-gutters>
          <v-col cols="12">
            <v-card flat tile>
              <div class="text-caption text-center title">
                Dettaglio assenze
              </div>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card outlined flat tile>
              <div class="text-center head text-caption">
                {{ item.mese }} {{ item.anno }}
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row
          no-gutters
          v-for="d in item.assenze.dettaglio"
          :key="d.codLegenda"
        >
          <v-col cols="8">
            <v-card outlined flat tile class="px-1 text-caption">{{
              d.descrizione
            }}</v-card>
          </v-col>
          <v-col cols="4">
            <v-card outlined flat tile class="px-1 text-caption">{{
              d.ore
            }}</v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </widget>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Widget from "./Widget.vue";
import mixin from "@/mixin";
import SearchBar from "./SearchBar.vue";

export default {
  name: "presenze-assenze",
  mixins: [mixin],
  components: {
    Widget,
    SearchBar,
  },
  mounted() {
    this.fetchData();
  },
  destroyed() {
    this.resetData();
  },
  data() {
    return { searchBtn: false };
  },
  methods: {
    updateData(da, a) {
      this.fetchData({ da, a });
    },
    toggleSearch() {
      this.searchBtn = !this.searchBtn;
    },
    ...mapActions({
      fetchData: "widget/fetchPresenceAbsence",
      resetData: "widget/resetPresenceAbsence",
    }),
  },
  computed: {
    ...mapGetters({
      item: "widget/presenceAbsence",
    }),
  },
};
</script>

<style>
.search .v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.search .v-input input {
  width: 100px;
  font-size: 0.8em;
}
</style>